// App.js
import React, { useState, useEffect, useContext } from 'react';
import Layout from './components/layout/Layout';
import Dashboard from './pages/dashboard/dashboardpage';
import BookAppointment from './pages/bookappointment/BookAppointmentForm';
import CheckIn from './pages/checkin/checkin';
import CheckOut from './pages/checkout/checkout';
import Login from './components/auth/Login';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import OTPVerification from './pages/bookappointment/otpverification'
import Visitorapplicationform from './pages/bookappointment/Visitorapplicationform'
import Otplinkexpired from './pages/bookappointment/Otplinkexpired'
import Submissionform from './pages/bookappointment/Submissionform'

import CheckinVisitorFormC from './pages/checkin/CheckinVisitorForm';
import walkinCheckin from './pages/checkin/walkinCheckin';

import { UsernameProvider } from './components/auth/UsernameContext';
import { VisitorProvider } from './pages/bookappointment/VisitorContext';
import { AppIdProvider } from './pages/bookappointment/AppIdContext';
import VisitorReportPage from './pages/reports/VisitorReports';
import AppoinmentReportPage from './pages/reports/AppointmentReports'
import GrouptReportPage from './pages/reports/GroupReports'
import GroupAppoinmentReportsPage from './pages/reports/GroupAppoinmentReports'
import BlackListReportPage from './pages/reports/BlacklistReports';
import FrequentVisitorPage from './pages/reports/FrequentVisitor';
import MonthwiseVisitorPage from './pages/reports/MonthwiseVisitor';
import DatewiseReportPage from './pages/reports/DatewiseReport';
import BlacklistPage from './pages/blackList/Blacklist';
import AddlocatonPage from './pages/masterUpdate/Addlocation';
import AddEmployeePage from './pages/masterUpdate/AddEmployee';
import AddidentityProofPage from './pages/masterUpdate/AddidentityProof';
import ConfigurationPage from './pages/masterUpdate/Configuration';
import EmployeeRoleMapPage from './pages/masterUpdate/EmployeeRoleMap';
import RoleMapPage from './pages/masterUpdate/RoleMenuMap';
import VisitorTypeMapPage from './pages/masterUpdate/VisitorTypeMap';
import MonthwiseFeedbackPage from './pages/reports/MonthwiseFeedback';
import DatewiseFeedbackPage from './pages/reports/DateWiseFeedback';
import FoodapprovalPage from './pages/foodapproval/FoodapprovalReport';
import ReprintPassPage from './pages/reprint/ReprintPass';
import ReportBugPage from './pages/help/ReportBug';
import GroupAppoinmentDetailsPage from './pages/groupAppoinment/GroupAppoinmentDetails';
import AppoinmentFormPage from './pages/groupAppoinment/appoinmentform';
import AppoinmentStatusPage from './pages/groupAppoinment/appoinmentStaus';
import GroupCheckInPage from './pages/groupCheck/GroupCheckIn';
import GroupCheckoutPage from './pages/groupCheck/GroupCheckOut';
import GroupAppoinmentFormPage from './pages/groupCheck/GroupAppoinmentForm';
import GroupMemberDetailsUploadPage from './pages/groupCheck/GroupMemberDetails';
import AddGatePage from './pages/masterUpdate/AddGate';
import AddBuildingPage from './pages/masterUpdate/AddBuilding';
// import SecurityapprovalPage from './pages/securityApproval/SecurityapprovalReport';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import WalkingChekInForm from './pages/checkin/walkinCheckin';
import SecurityapprovalPage from './pages/foodapproval/SecurityPage';
import SingleAppoinmentStatusPage from './pages/bookappointment/SingleAppointmentStatus';
import AllVisitorReportPage from './pages/reports/AllVisitorsReport';
import CardIssuranceReportPage from './pages/reports/CardIssuranceReport';
import ReceptionWorkloadReportPage from './pages/reports/ReceptionWorkload';
import AddNationalityPage from './pages/masterUpdate/AddNationality';
import AddEmpTypePage from './pages/masterUpdate/AddEmpType';
import SSOLoginPage from './components/auth/SS0Login';
import VisitorTypeSelectionPage from './pages/bookappointment/visitorTypeSelection';
import VisitorTypeSelectionGroupPage from './pages/groupAppoinment/visitorTypeSelectionGroup';
import AppoinmentFormLeaderPage from './pages/groupAppoinment/groupLeaderApplicationForm';
import GroupMemberApplicationPage from './pages/groupAppoinment/groupMemberApplicationForm';
import CourierMaster from './pages/masterUpdate/CourierMaster';
import KeyMaster from './pages/masterUpdate/KeyMaster';
import AddEntityPage from './pages/keyManagement/keyRegister';
import OutwardCourierPage from './pages/courierRegister/OutwardCourier';
import InwardCourierPage from './pages/courierRegister/InwardCourier';
import ChangePassword from './pages/masterUpdate/ChangePassword';
import ChangePasswordPage from './pages/masterUpdate/ChangePassword';
import AreaCheckIn from './pages/AreaCheckin-VisitorTraking/AreaCheckin';
import VisitorTackingPage from './pages/AreaCheckin-VisitorTraking/visitorTraing';
import DashboardMaterial from './pages/material-management/materialDashboard';
import TransactionPage from './pages/material-management/management';
import CreateTransactionForm from './pages/material-management/createTrans';
import AddEntityPageMaster from './pages/masterUpdate/AddEntity';
import BadgeTemplatePage from './pages/masterUpdate/BadgeTemplate';
import BadgeTemplatePreviewPage from './pages/masterUpdate/BadgeTemplatePreviewPage';
import AddDesignationPage from './pages/masterUpdate/AddDesignation';
import AddDepartmentPage from './pages/masterUpdate/AddDepartment';

function App() {
  return (
    <div className="App">
      <UsernameProvider> {/* Ensure UsernameProvider wraps your routes */}
        <VisitorProvider>

          <Routes>
            <Route path="/login" element={<Login />} />
          </Routes>
          <Routes>

            <Route path="/layout" element={<Layout />}>
              <Route path="/layout/Dashboard/Dashboard" element={<Dashboard />} />
              <Route path="/layout/BookAppointment/BookAppointment" element={<BookAppointment />} />
              <Route path="/layout/AppointmentStatus/SingleAppointmentStatus" element={<SingleAppoinmentStatusPage />} />
              {/* <Route path="/layout/ChangePassword/ChangePassword" element={<ChangePassword />} /> */}

              <Route path="/layout/individual-appointment" element={<BookAppointment />} />
              <Route path="/layout/LinkToVisitor/LinkToVisitor" element={<VisitorTypeSelectionPage />} />
              <Route path="/layout/CheckIn/MenuItem" element={<CheckIn />} />
              <Route path="/layout/check-visitoriForm" element={<CheckinVisitorFormC />} />
              <Route path="/layout/walkin-check-in" element={<WalkingChekInForm />} />
              <Route path="/layout/Configuration/Configuration" element={<ConfigurationPage />} />

              <Route path="/layout/Reports/Report" element={<VisitorReportPage />} />
              <Route path="/layout/Reports/AllVisitorsReport" element={<AllVisitorReportPage />} />
              <Route path="/layout/Reports/CardIssuanceReport" element={<CardIssuranceReportPage />} />
              <Route path="/layout/Reports/ReceptionWorkloadbyLocationReport" element={<ReceptionWorkloadReportPage />} />
              <Route path="/layout/AppointmentReport/AppointmentReport" element={<AppoinmentReportPage />} />
              <Route path="/layout/groupAppointmentReport/groupAppointmentReport" element={<GrouptReportPage />} />
              <Route path="/layout/Reports/groupAppointmentReport" element={<GroupAppoinmentReportsPage />} />
              <Route path="/layout/BlackListReport/BlackListReport" element={<BlackListReportPage />} />
              <Route path="/layout/Reports/FrequentVisitorReport" element={<FrequentVisitorPage />} />
              <Route path="/layout/Reports/MonthWiseVisitorReport" element={<MonthwiseVisitorPage />} />
              <Route path="/layout/Reports/DayWiseVisitorReport" element={<DatewiseReportPage />} />
              <Route path="/layout/monthwise-feedback" element={<MonthwiseFeedbackPage />} />
              <Route path="/layout/datewise-feedback" element={< DatewiseFeedbackPage />} />
              <Route path="/layout/BlackList/BlackList" element={<BlacklistPage />} />
              <Route path="/layout/AddLocation/AddLocation" element={<AddlocatonPage />} />
              <Route path="/layout/AddIdentityProof/AddIdentityProof" element={<AddidentityProofPage />} />
              <Route path="/layout/AddEmployee/AddEmployee" element={<AddEmployeePage />} />
              <Route path="/layout/configuration" element={<ConfigurationPage />} />
              <Route path="/layout/EmployeeRoleMapping/EmployeeRoleMapping" element={<EmployeeRoleMapPage />} />
              <Route path="/layout/RoleMenuMap/RoleMenuMap" element={<RoleMapPage />} />
              <Route path="/layout/VisitorType/VisitorType" element={<VisitorTypeMapPage />} />
              <Route path="/layout/Checkout/MenuItem" element={<CheckOut />} />
              <Route path="/layout/food-approval" element={<FoodapprovalPage />} />
              <Route path="/layout/security-approval" element={<SecurityapprovalPage />} />
              <Route path="/layout/Reprint/ReprintVisitor" element={<ReprintPassPage />} />
              <Route path="/layout/report-bug" element={<ReportBugPage />} />
              <Route path="/layout/group-appoinment-details" element={<GroupAppoinmentDetailsPage />} />
              <Route path="/layout/GroupAppointment-form" element={<AppoinmentFormPage />} />
              <Route path="/layout/GroupAppointment/GroupAppointment" element={<VisitorTypeSelectionGroupPage />} />
              <Route path="/layout/AppointmentStatus/AppointmentStatus" element={<AppoinmentStatusPage />} />
              <Route path="/layout/GroupCheckIn/MenuItem" element={<GroupCheckInPage />} />
              <Route path="/layout/GroupCheckIn/GroupCheckout" element={<GroupCheckoutPage />} />
              <Route path="/layout/group-CheckIn-form" element={<GroupAppoinmentFormPage />} />
              <Route path="/layout/group-member-page" element={<GroupMemberDetailsUploadPage />} />
              <Route path="/layout/AddGate/AddGate" element={<AddGatePage />} />
              <Route path="/layout/AddBuilding/AddBuilding" element={<AddBuildingPage />} />
              <Route path="/layout/AddNationality/AddNationality" element={<AddNationalityPage />} />
              <Route path="/layout/AddEmployeeType/AddEmployeeType" element={<AddEmpTypePage />} />
              <Route path="/layout/ChangePassword/ChangePassword" element={<ChangePasswordPage />} />
              <Route path="/layout/AddCourier/AddCourier" element={<CourierMaster />} />
              <Route path="/layout/AddKey/AddKey" element={<KeyMaster />} />
              <Route path="/layout/AddKeyManagement/AddKeyManagement" element={<AddEntityPage />} />
              <Route path="/layout/AddOutwardCourier/AddOutwardCourier" element={<OutwardCourierPage />} />
              <Route path="/layout/AddInwardCourier/AddInwardCourier" element={<InwardCourierPage />} />
              <Route path="/layout/AreaCheck-In/AreaCheck-In" element={<AreaCheckIn />} />
              <Route path="/layout/Reports/VisitorTracking" element={<VisitorTackingPage />} />
              <Route path="/layout/MaterialManagement/Dashboard" element={<DashboardMaterial />} />
              <Route path="/layout/MaterialManagement/MaterialTransaction" element={<TransactionPage />} />
              <Route path="/layout/add-material" element={<CreateTransactionForm />} />
              <Route path="/layout/Entity/Entity" element={<AddEntityPageMaster />} />
              <Route path="/layout/BadgeTemplateMapping/BadgeTemplateMapping" element={<BadgeTemplatePage />} />
              <Route path="/layout/BadgeTemplate/BadgeTemplate" element={<BadgeTemplatePreviewPage />} />
              <Route path="/layout/Department/AddDepartment" element={<AddDepartmentPage />} />
              <Route path="/layout/Designation/AddDesignation" element={<AddDesignationPage />} />




            </Route>

          </Routes>
          <Routes>
            <Route path="/otp-verification" element={<OTPVerification />} />
          </Routes>
          <Routes>
            <Route path="/visitor-form" element={<Visitorapplicationform />} />
          </Routes>
          <Routes>
            <Route path="/group-form" element={<AppoinmentFormLeaderPage />} />
          </Routes>
          <Routes>
            <Route path="/group-appoinment-details" element={<GroupMemberApplicationPage />} />
          </Routes>
          <Routes>
            <Route path="/otp-expired" element={<Otplinkexpired />} />
          </Routes>
          <Routes>
            <Route path="/form-submitted" element={<Submissionform />} />
          </Routes>
          <Routes>
            <Route path="/sso-login-bridge" element={<SSOLoginPage />} />
          </Routes>

        </VisitorProvider>
      </UsernameProvider>
    </div>
  );
}

export default App;
